const BOOKING_AUTHENTICATION_DATA = {
  email: {
    id: "email",
    errors: {
      EMPTY: {
        track: "email_missing_error",
        key: "mytripslogin.booking.authentication.error.email.empty"
      },
      FORMAT: {
        track: "email_invalid_error",
        key: "mytripslogin.booking.authentication.error.email.format",
        validator: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
      }
    }
  },
  bookingReference: {
    id: "bookingReference",
    errors: {
      EMPTY: {
        track: "reference_missing_error",
        key: "mytripslogin.booking.authentication.error.reference.empty"
      },
      FORMAT: {
        track: "reference_invalid_error",
        key: "mytripslogin.booking.authentication.error.reference.format",
        validator: /^\d{10,11}$/
      }
    }
  },
  global: {
    INVALID_REQUEST: {
      track: "reference_and_email_dont_match_error",
      key: "mytripslogin.booking.authentication.error.notfound"
    }
  }
};
export default BOOKING_AUTHENTICATION_DATA;